<template lang="pug">

section.src-components-rescajas
  v-app-bar(app color="indigo darken-2" dark)
    nav
      v-btn(icon @click="$router.go(-1)") #[v-icon mdi-arrow-left]  
      router-link.ma-2(to="/")
        v-icon mdi-home
        span.ma-2 Cajas    
    v-app-bar-title Reporte Cajas 
    v-spacer
    v-btn(icon @click="print()") #[v-icon mdi-printer]  
  v-card.ma-2
    v-card-title
      Datepicker(:startDate="startDate" title="Desde" @date="desde($event)")
      Datepicker(:startDate="stopDate" title="Hasta" @date="hasta($event)")
      v-btn.ma-2(dark @click="getCajas()" color="primary") Traer Datos
  v-card.ma-2(v-if="visible" v-for="(em,idx) in empresaMedioDePago" :key="idx")
    v-card-title {{ em.name }}
    v-card-text
      .d-flex.justify-center.flex-wrap 
        div.ma-3(v-for="(item,index) in em.pagos" :key="index")
          h3 {{item.name}} #[v-chip(color="purple" dark small) {{ item.qty }}]
          span {{$formatNumber(item.amount)}}
      
      p
        h4 Total Caja: {{ $formatNumber(em.totalCaja) }}, Total Ventas: {{ $formatNumber(em.totalVentas) }} Cant Ventas: {{em.cantVtas}}
  p
    h4(v-if="visible") Total Caja General: {{ $formatNumber(totalCaja) }}, Total Ventas General: {{ $formatNumber(totalVtas) }} Cant Ventas: {{ cantVtas }}
    h4(v-else) Seleccione las fechas del periodo a consultar y haga click en TRAER DATOS
</template>
  
  <script lang="js">
    import Datepicker from './Datepicker.vue'
    export default  {
      name: 'src-components-rescajas',
      props: [],
      components: {Datepicker},
      mounted () {
        this.clear()
      },
      data () {
        return {
          visible:false,
          startDate:this.defaultDate(),
          stopDate:this.defaultDate(),
          cajas:[],
          totalCaja:0,
          totalVtas:0,
          cantVtas:0,
          empresaMedioDePago:null
        }
      },
      methods: {
        print() {
          window.ipcRenderer.invoke('print').then(() => {
          }).catch((err) => {alert(err)})
        },
        desde(date) {
          this.startDate = date
        },
        hasta(date) {
          this.stopDate = date
        },
        clear() {
          this.cantVtas = 0
          this.totalCaja = 0
          this.totalVtas = 0
          this.empresaMedioDePago=[
              {
                  name: "El Desembarco",
                  pagos: [],
                  totalCaja:0,
                  totalVentas:0,
                  cantVtas:0,
              },
              {
                  name: "Panchos",
                  pagos: [],
                  totalCaja:0,
                  totalVentas:0,
                  cantVtas:0,                  
              },
              {
                  name: "Milanesas",
                  pagos: [],
                  totalCaja:0,
                  totalVentas:0,
                  cantVtas:0,
              },
          ]          
        },
        toventa(item) {
          this.$router.push(`/ventas/${item.Idsesion}/${item.estado}`)
        },
        toresumen(item) {
          this.$router.push({
              name: 'cajaresumen',
              params: {
                  caja:item
              }
          })
        },
        defaultDate() {
          let date = new Date().toISOString()
          return new String(date).substring(0,10)
        },
        getCajas() {
          this.loading = true
          this.visible = false
          this.clear()
          let sql = `SELECT Idsesion, estado, fechaapertura, horaapertura, fechacierre,horacierre, NROTURNO , TotalGeneral
          FROM sesion where fechaapertura between '${this.startDate}' and '${this.stopDate}'`
          window.ipcRenderer.invoke('sqlQuery',sql).then((ret) => {
            this.cajas = ret
            this.getInfo()
          }).catch((err) => {alert(err)})
          .finally(() => {
            this.loading = false
          });
        },
        async getInfo() {
          for (let caja of this.cajas) {
            let cajaDatos = await window.ipcRenderer.invoke('getCaja',caja.Idsesion)
            for (let empresa of cajaDatos.datos) {
              let emp = this.empresaMedioDePago.find((it)=>it.name==empresa.name)
              emp.cantVtas += empresa.cantVtas
              emp.totalCaja += empresa.totalCaja
              emp.totalVentas += empresa.totalVentas
              for (let pago of empresa.pagos) {
                let pgo = emp.pagos.find((it)=>it.id==pago.id) 
                if (!pgo) {
                  emp.pagos.push(pago)
                } else {
                  pgo.amount += pago.amount
                  pgo.qty += pago.qty
                }
              }
            }
            this.cantVtas += cajaDatos.cantVtas
            this.totalCaja += cajaDatos.totalCaja
            this.totalVtas += cajaDatos.totalVtas
          }
          this.visible=true
        } 
      },
      computed: {
  
      }
  }
  
  
  </script>
  
  <style scoped lang="scss">
    .src-components-rescajas {
  
    }
  </style>
  